// @owners { team: patients }
import { type ReduxStateShared } from '~shared/store';

export const getApplePaySupported = (state: ReduxStateShared) => {
  return state.persistedUI.applePay.isApplePaySupported || false;
};
